var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ItemList',{attrs:{"events":_vm.filteredEvents,"category":"Events"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }